enum GqlError {
  NetworkError = "NetworkError",
  InternalServerError = "InternalServerError",
  BAD_USER_INPUT = "BAD_USER_INPUT"

}

export {GqlError}